module.exports = __webpack_public_path__ + "static/media/抽奖按钮.e8acd1ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_110/images/抽奖按钮.png
// module id = 1103
// module chunks = 0